import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { CloseButton } from '.';
import { Typography } from '../../Typography';
import OnsolvePropTypes from '../../utils/PropTypes';

const ModalHeader = ({ id, icon, title, onClose, onCloseKeyDown, classes, closeIconColor, variant }) => (
    <div className={classNames('modal-header onsolve-alert-modal__header', classes.root)}>
        {icon && <div className="onsolve-alert-modal__icon">{icon}</div>}
        <Typography
            id={id}
            variant={variant}
            className={classNames('modal-title onsolve-alert-modal__title', classes.title)}
        >
            {title}
        </Typography>
        <CloseButton
            className="onsolve-alert-modal__close"
            onKeyDown={onCloseKeyDown}
            onClose={onClose}
            color={closeIconColor}
        />
    </div>
);

ModalHeader.defaultProps = {
    classes: {},
    variant: 'h3'
};

ModalHeader.propTypes = {
    classes: PropTypes.shape({
        root: PropTypes.string,
        title: PropTypes.string
    }),
    closeIconColor: PropTypes.string,
    icon: PropTypes.element,
    id: PropTypes.string,
    onClose: PropTypes.func,
    onCloseKeyDown: PropTypes.func,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    /**
    Specifies the theme typography styles.
    */
    variant: OnsolvePropTypes.headersTextVariants
};

ModalHeader.displayName = 'ModalHeader';

export default ModalHeader;
